<section
  class="chat-popup"
  *ngIf="isChatOpen"
  [style.width.px]="chatWidth"
  [style.height.px]="chatHeight"
>
  <header class="chat-header">
    <h3>Chat with TechNews AI</h3>
  </header>

  <div class="chat-messages">
    <p class="chat-empty" *ngIf="messages.length === 0">
      What do you want to know about?
    </p>
    <div
      class="chat-message"
      [ngClass]="message.role"
      *ngFor="let message of messages"
    >
      <strong>{{ message.role === 'user' ? 'You' : 'Assistant' }}:</strong>
      <ng-container *ngIf="message.role === 'user'">
        {{ message.text }}
      </ng-container>
      <div
        *ngIf="message.role === 'assistant'"
        class="chat-message-content"
        [innerHTML]="renderMarkdown(message.text)"
      ></div>
    </div>
    <p class="chat-thinking" *ngIf="isSending">Thinking...</p>
  </div>

  <form class="chat-form" (ngSubmit)="sendPrompt()">
    <textarea
      name="chatPrompt"
      [(ngModel)]="prompt"
      [disabled]="isSending"
      placeholder="Type your prompt..."
      rows="3"
    ></textarea>

    <p class="chat-error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <button type="submit" [disabled]="isSending || !prompt.trim()">Send</button>
  </form>

  <button
    class="chat-resize-handle"
    type="button"
    aria-label="Resize chat window"
    (mousedown)="startResize($event)"
  ></button>
</section>
